import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Section } from "@/components/ui-brand";

// Inline **bold** only; the document text comes verbatim from the backend.
const Inline = ({ text }) => text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
  part.startsWith("**") && part.endsWith("**") ? <strong key={i}>{part.slice(2, -2)}</strong> : <Fragment key={i}>{part}</Fragment>);

const Body = ({ texto }) => texto.split(/\n\s*\n/).map((block, i) => {
  const lines = block.split("\n");
  if (lines.every((l) => l.startsWith("- "))) {
    return <ul key={i} className="list-disc pl-5 space-y-1">{lines.map((l, j) => <li key={j}><Inline text={l.slice(2)} /></li>)}</ul>;
  }
  return <p key={i}><Inline text={block} /></p>;
});

export const LegalDoc = ({ endpoint, slug, footerLabel, related }) => {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => { api.get(endpoint).then((r) => setDoc(r.data)).catch(() => setError(true)); }, [endpoint]);

  if (error) return <Section className="py-14"><p data-testid={`${slug}-error`}>No se pudo cargar el documento. Probá de nuevo más tarde.</p></Section>;
  if (!doc) return <Section className="py-14"><p data-testid={`${slug}-loading`}>Cargando…</p></Section>;
  return (
    <Section className="py-10 sm:py-14 max-w-3xl">
      <article data-testid={`${slug}-page`}>
        <h1 className="h-section text-2xl sm:text-3xl mb-2 leading-tight" data-testid={`${slug}-title`}>{doc.titulo}</h1>
        <p className="text-xs font-semibold tracking-wide text-[var(--brand-accent)] mb-8">Versión {doc.version}</p>
        <div className="space-y-7">
          {doc.secciones.map((s, i) => (
            <section key={s.titulo} data-testid={`${slug}-seccion-${i + 1}`}>
              <h2 className="font-heading font-bold text-base sm:text-lg text-[var(--brand-primary)] mb-2">{s.titulo}</h2>
              <div className="text-sm sm:text-base leading-relaxed text-slate-700 space-y-3"><Body texto={s.texto} /></div>
            </section>
          ))}
        </div>
        <footer className="mt-10 pt-5 border-t border-[var(--brand-border)] text-xs text-[var(--brand-text-muted)] flex flex-wrap justify-between gap-2" data-testid={`${slug}-version`}>
          <span>{footerLabel} · Versión {doc.version}</span>
          {related && <Link to={related.to} className="underline hover:text-[var(--brand-primary)]" data-testid={`${slug}-related-link`}>{related.label}</Link>}
        </footer>
      </article>
    </Section>
  );
};
